import React from "react";
import { useLocation } from "@reach/router";
import { Widget } from "@typeform/embed-react";

export const TypeFormWidget = ({ user }) => {
  return (
    <Widget
      id="g36Mcg5i"
      className="typeform-widget eva-mt-05"
      hidden={{
        url_atual: useLocation().href,
        produto: "JORNALISMO",
        user_id: user && user.id,
        etapas: user && user.etapas && user.etapas.map((el) => el.etapas),
        disciplinas:
          user &&
          user.disciplinas &&
          user.disciplinas.map((el) => el.disciplinas),
        estado:
          user &&
          user.enderecos &&
          user.enderecos.length > 0 &&
          user.enderecos[0].estado
            ? user.enderecos[0].estado
            : "",
        ocupacao: user && user.ocupacao,
        raca: user && user.raca,
      }}
    />
  );
};
